import type { HolderLockupStatus } from 'src/pages/admin/services/vaultService';

export const INVESTORS_PERMISSION_RESOURCE = 'vault:investors';

export const INVESTORS_NS = 'module.vaultInvestors';

/** C-06 `HolderLockupStatus`, in schema order; the engine stays the authority. */
export const HOLDER_LOCKUP_STATUSES: readonly HolderLockupStatus[] = [
  'UNLOCKED',
  'LOCKED',
  'STAKE_LOCKED',
];

/** Page sizes the console offers; every one is within the engine's 1–200. */
export const ROWS_PER_PAGE_OPTIONS = [20, 50, 100];
export const DEFAULT_ROWS_PER_PAGE = 50;

/** The BFF's 404 when the engine knows no vault under the id (VaultAdmin_VaultNotFound). */
export const VAULT_NOT_FOUND = 'VAULT_NOT_FOUND';
